import {
	Card,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	TableSortLabel,
	withStyles,
} from "@material-ui/core";
import usePagination from "../../../hooks/usePagination";
import PromptsTableActionHeader from "./PromptsTableActionHeader";
import PromptsTableRow from "./PromptsTableRow";
import { columnsDefinition, isPacePrompt } from "./utils";

const StyledTableCell = withStyles((_theme) => ({
	head: {
		padding: "24px 24px 12px 16px",
	},
}))(TableCell);

const PromptsList = ({
	languages,
	namespaces,
	onRefresh,
	onExport,
	setFilterTerm,
	config,
	onFileImport,
	onSelect,
	onPromptAdd,
	prompts,
	setEditPrompt,
	fileProcessingState,
	showMessage,
	getConnectPromptName,
	deletePrompt,
	filterType,
	setFilterType,
	setSortConfig,
	sortConfig,
}) => {
	const { setPageNo, setRowsPerPage, pageNo, dataSlice, rowsPerPage } = usePagination(prompts);

	const handleRequestSort = (_event, property) => {
		const isAsc = sortConfig.orderBy === property && sortConfig.order === "asc";
		setSortConfig({ order: isAsc ? "desc" : "asc", orderBy: property });
	};

	const createSortHandler = (property) => (event) => {
		handleRequestSort(event, property);
	};

	const rows = dataSlice?.map((prompt) => {
		const canDelete = isPacePrompt(prompt);
		return (
			<PromptsTableRow
				canDelete={!canDelete}
				key={prompt.promptId}
				getConnectPromptName={getConnectPromptName}
				prompt={prompt}
				showMessage={showMessage}
				editPrompt={() => setEditPrompt(prompt)}
				deletePrompt={() => deletePrompt(prompt)}
			/>
		);
	});

	return (
		<Card style={{ minWidth: 1080 }}>
			<div>
				<PromptsTableActionHeader
					languages={languages}
					namespaces={namespaces}
					onRefresh={onRefresh}
					onExport={onExport}
					setFilterTerm={setFilterTerm}
					config={config}
					onFileImport={onFileImport}
					fileProcessingState={fileProcessingState}
					onSelect={onSelect}
					onPromptAdd={onPromptAdd}
					setFilterType={setFilterType}
					filterType={filterType}
					handleRequestSort={handleRequestSort}
				/>
			</div>
			<Table size="small" className="w-100">
				<TableHead>
					<TableRow>
						{columnsDefinition.map((column) => (
							<StyledTableCell key={column.title}>
								{column.hasSorting ? (
									<TableSortLabel
										active={sortConfig.orderBy === column.field}
										direction={sortConfig.orderBy === column.field ? sortConfig.order : "asc"}
										onClick={createSortHandler(column.field)}
									>
										{column.title}
									</TableSortLabel>
								) : (
									column.title
								)}
							</StyledTableCell>
						))}
						<StyledTableCell style={{ minWidth: 150 }}></StyledTableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{!prompts.length ? (
						<TableRow>
							<TableCell colSpan={7} style={{ height: 60 }} align="center">
								No prompts found.
							</TableCell>
						</TableRow>
					) : (
						rows
					)}
				</TableBody>
			</Table>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25]}
				component="div"
				count={prompts.length}
				rowsPerPage={rowsPerPage}
				page={pageNo}
				onPageChange={(e, pageNo) => setPageNo(pageNo)}
				onRowsPerPageChange={(rowsPerPageCnt) => {
					setRowsPerPage(parseInt(rowsPerPageCnt.currentTarget.innerText) || 10);
					setPageNo(0);
				}}
			/>
		</Card>
	);
};

export default PromptsList;
